"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cola = require("webcola");
var geometry_1 = require("../diagram/geometry");
var events_1 = require("./events");
var paperArea_1 = require("../diagram/paperArea");
function forceLayout(params) {
    var layout = new cola.Layout()
        .nodes(params.nodes)
        .links(params.links)
        .avoidOverlaps(params.avoidOvelaps)
        .convergenceThreshold(1e-9)
        .jaccardLinkLengths(params.preferredLinkLength)
        .handleDisconnected(true);
    layout.start(30, 0, 10, undefined, false);
}
exports.forceLayout = forceLayout;
function removeOverlaps(nodes) {
    var nodeRectangles = [];
    for (var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++) {
        var node = nodes_1[_i];
        nodeRectangles.push(new cola.Rectangle(node.x, node.x + node.width, node.y, node.y + node.height));
    }
    cola.removeOverlaps(nodeRectangles);
    for (var i = 0; i < nodeRectangles.length; i++) {
        var node = nodes[i];
        var rectangle = nodeRectangles[i];
        node.x = rectangle.x;
        node.y = rectangle.y;
    }
}
exports.removeOverlaps = removeOverlaps;
function translateToPositiveQuadrant(nodes, offset) {
    var minX = Infinity, minY = Infinity;
    for (var _i = 0, nodes_2 = nodes; _i < nodes_2.length; _i++) {
        var node = nodes_2[_i];
        minX = Math.min(minX, node.x);
        minY = Math.min(minY, node.y);
    }
    var x = offset.x, y = offset.y;
    for (var _a = 0, nodes_3 = nodes; _a < nodes_3.length; _a++) {
        var node = nodes_3[_a];
        node.x = node.x - minX + x;
        node.y = node.y - minY + y;
    }
}
exports.translateToPositiveQuadrant = translateToPositiveQuadrant;
function uniformGrid(params) {
    return function (cellIndex) {
        var row = Math.floor(cellIndex / params.rows);
        var column = cellIndex - row * params.rows;
        return {
            x: column * params.cellSize.x,
            y: row * params.cellSize.y,
            width: params.cellSize.x,
            height: params.cellSize.y,
        };
    };
}
exports.uniformGrid = uniformGrid;
function padded(nodes, padding, transform) {
    if (padding) {
        for (var _i = 0, nodes_4 = nodes; _i < nodes_4.length; _i++) {
            var node = nodes_4[_i];
            node.x -= padding.x;
            node.y -= padding.y;
            node.width += 2 * padding.x;
            node.height += 2 * padding.y;
        }
    }
    transform();
    if (padding) {
        for (var _a = 0, nodes_5 = nodes; _a < nodes_5.length; _a++) {
            var node = nodes_5[_a];
            node.x += padding.x;
            node.y += padding.y;
            node.width -= 2 * padding.x;
            node.height -= 2 * padding.y;
        }
    }
}
exports.padded = padded;
function recursiveLayout(params) {
    var grouping = geometry_1.computeGrouping(params.model.elements);
    var layoutFunction = params.layoutFunction, model = params.model, fixedElementIds = params.fixedElementIds;
    internalRecursion(params.group);
    function internalRecursion(group) {
        var elements = group
            ? grouping.get(group)
            : model.elements.filter(function (el) { return el.group === undefined; });
        for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
            var element = elements_1[_i];
            if (grouping.has(element.id)) {
                internalRecursion(element.id);
            }
        }
        var nodes = [];
        var nodeById = {};
        for (var _a = 0, elements_2 = elements; _a < elements_2.length; _a++) {
            var element = elements_2[_a];
            var _b = geometry_1.boundsOf(element), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
            var node = {
                id: element.id,
                x: x, y: y, width: width, height: height,
                fixed: fixedElementIds && fixedElementIds.has(element.id) ? 1 : 0,
            };
            nodeById[element.id] = node;
            nodes.push(node);
        }
        var links = [];
        for (var _c = 0, _d = model.links; _c < _d.length; _c++) {
            var link = _d[_c];
            if (!model.isSourceAndTargetVisible(link)) {
                continue;
            }
            var source = model.sourceOf(link);
            var target = model.targetOf(link);
            var sourceNode = nodeById[source.id];
            var targetNode = nodeById[target.id];
            if (sourceNode && targetNode) {
                links.push({ source: sourceNode, target: targetNode });
            }
        }
        layoutFunction(nodes, links, group);
        if (group) {
            var offset = paperArea_1.getContentFittingBox(elements, []);
            translateToPositiveQuadrant(nodes, offset);
        }
        for (var _e = 0, nodes_6 = nodes; _e < nodes_6.length; _e++) {
            var node = nodes_6[_e];
            var element = model.getElement(node.id);
            element.setPosition({ x: node.x, y: node.y });
        }
    }
}
exports.recursiveLayout = recursiveLayout;
function placeElementsAround(params) {
    var model = params.model, elements = params.elements, targetElement = params.targetElement, prefferedLinksLength = params.prefferedLinksLength;
    var targetElementBounds = geometry_1.boundsOf(targetElement);
    var targetPosition = {
        x: targetElementBounds.x + targetElementBounds.width / 2,
        y: targetElementBounds.y + targetElementBounds.height / 2,
    };
    var outgoingAngle = 0;
    if (targetElement.links.length > 0) {
        var xSum = 0;
        var ySum = 0;
        for (var _i = 0, _a = targetElement.links; _i < _a.length; _i++) {
            var link = _a[_i];
            var linkSource = model.sourceOf(link);
            var source = linkSource !== targetElement ? linkSource : model.targetOf(link);
            xSum += source.position.x + source.size.width / 2;
            ySum += source.position.y + source.size.height / 2;
        }
        var averageSourcePosition = {
            x: xSum / targetElement.links.length, y: ySum / targetElement.links.length,
        };
        var vectorDiff = {
            x: targetPosition.x - averageSourcePosition.x, y: targetPosition.y - averageSourcePosition.y,
        };
        if (vectorDiff.x !== 0 || vectorDiff.y !== 0) {
            outgoingAngle = Math.atan2(vectorDiff.y, vectorDiff.x);
        }
    }
    var step = Math.min(Math.PI / elements.length, Math.PI / 6);
    var elementsSteck = [].concat(elements);
    var placeElementFromSteck = function (curAngle, element) {
        if (element) {
            var size = element.size;
            element.setPosition({
                x: targetPosition.x + prefferedLinksLength * Math.cos(curAngle) - size.width / 2,
                y: targetPosition.y + prefferedLinksLength * Math.sin(curAngle) - size.height / 2,
            });
        }
    };
    var isOddLength = elementsSteck.length % 2 === 0;
    if (isOddLength) {
        for (var angle = step / 2; elementsSteck.length > 0; angle += step) {
            placeElementFromSteck(outgoingAngle - angle, elementsSteck.pop());
            placeElementFromSteck(outgoingAngle + angle, elementsSteck.pop());
        }
    }
    else {
        placeElementFromSteck(outgoingAngle, elementsSteck.pop());
        for (var angle = step; elementsSteck.length > 0; angle += step) {
            placeElementFromSteck(outgoingAngle - angle, elementsSteck.pop());
            placeElementFromSteck(outgoingAngle + angle, elementsSteck.pop());
        }
    }
    return new Promise(function (resolve) {
        var listener = new events_1.EventObserver();
        listener.listen(model.events, 'changeCells', function () {
            listener.stopListening();
            recursiveRemoveOverlaps({
                model: model,
                padding: { x: 15, y: 15 },
            });
            resolve();
        });
    });
}
exports.placeElementsAround = placeElementsAround;
function recursiveRemoveOverlaps(params) {
    var padding = params.padding, model = params.model, group = params.group, fixedElementIds = params.fixedElementIds;
    recursiveLayout({
        model: model,
        group: group,
        fixedElementIds: fixedElementIds,
        layoutFunction: function (nodes) {
            padded(nodes, padding, function () { return removeOverlaps(nodes); });
        },
    });
}
exports.recursiveRemoveOverlaps = recursiveRemoveOverlaps;
